'use strict';

var Assign = require('object-assign');
var EventEmitter = require('events').EventEmitter;

/**
 * This is a base class / mixin to add a standard event system.  
 * This is most likely used on Stores in the flux architecture.
 */
module.exports = Assign({}, EventEmitter.prototype, {
    /**
     * Adds a change listener for the {changeType}
     * @param {string} changeType
     * @param {func} callback
     */
    addChangeListener: function addChangeListener(changeType, callback) {
        this.on(changeType, callback);
    },

    /**
     * Removes a change listener of {changeType}
     * @param {string} changeType
     * @param {func} callback
     */
    removeChangeListener: function removeChangeListener(changeType, callback) {
        this.removeListener(changeType, callback);
    },

    /**
     * Emits a notification based on the name passed in
     * @param {string} changeType
     */
    emitChange: function emitChange(changeType) {
        this.emit(changeType);
    }
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/common-web/dist/lib/BaseEventEmitter.js
// module id = 327
// module chunks = 0